import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Cookies from 'js-cookie'
import { useSelector, useDispatch } from 'react-redux'
import { get } from 'lodash'

import API from 'api'
import { attemptLogin } from 'redux-web/utils/authentication/actions'
import { getAppRoute } from 'helpers/application'
import { onLogout } from 'redux-web/utils/user/actions'
// import { useTranslation } from 'i18n-web/i18next'

const WithSignUp = WrapperComponent => {
  const Wrapper = props => {
    const { application, queryData, router } = props

    // const { t } = useTranslation()
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const session = useSelector(state => state.session)
    const parentDomain = useSelector(state => state.settings.parentDomain)
    const [verifyEmailMessage, setVerifyEmailMessage] = useState(false)
    const [verifiedEmailMessage, setVerifiedEmailMessage] = useState(false)
    const [loadingPage, setLoadingPage] = useState(true)

    useEffect(() => {
      const authenticationToken = Cookies.get('appleAuthToken')

      // Apple login redirection
      if (authenticationToken) {
        dispatch(
          attemptLogin({
            isSignUpFlow: true,
            data: {
              authenticationToken,
            },
          })
        )
        Cookies.remove('citifyd_apple_login_redirect')
        routeRedirection()
      }

      if (process.env.NEXT_PUBLIC_ENABLE_PAY_BY_SIGNAGE_ONLY) {
        window.scrollTo(0, 0)
      }
    }, [])

    useEffect(() => {
      if (session.loggedIn && get(user.me, 'id')) {
        if (!user.me.isGuest) {
          signUpRedirection()
        } else {
          setLoadingPage(false)
        }
      } else {
        setLoadingPage(false)
      }
    }, [user, session])

    const signUpRedirection = async () => {
      const email = get(queryData, 'email')
      const phoneNumber = get(queryData, 'phoneNumber')
      const userEmail = get(user.me, 'email')
      const userPhoneNumber = get(user.me, 'phoneNumber')

      if (email && phoneNumber) {
        if (email === userEmail || phoneNumber === userPhoneNumber) {
          routeRedirection()
        } else {
          dispatch(onLogout())
        }
      } else if (!verifyEmailMessage && !verifiedEmailMessage) {
        routeRedirection()
      }
    }

    const routeRedirection = () => {
      const redirectTo =
        get(router, 'query.redirectTo') ||
        Cookies.get('citifyd_apple_login_redirect')

      Cookies.remove('citifyd_apple_login_redirect')

      if (redirectTo) {
        router.push(redirectTo)
      } else {
        API()
          .countTickets()
          .then(resp => {
            if (resp.count === 0) {
              router.push(
                `${getAppRoute(application, 'as')}/events`,
                `${getAppRoute(application, 'url')}/events`
              )
            } else {
              router.push(
                `${getAppRoute(application, 'as')}/my-passes`,
                `${getAppRoute(application, 'url')}/my-passes`
              )
            }
          })
      }
    }

    return (
      <WrapperComponent
        {...props}
        loadingPage={loadingPage}
        parentDomain={parentDomain}
        setVerifiedEmailMessage={setVerifiedEmailMessage}
        setVerifyEmailMessage={setVerifyEmailMessage}
        // t={t}
        verifiedEmailMessage={verifiedEmailMessage}
        verifyEmailMessage={verifyEmailMessage}
      />
    )
  }

  // if (WrapperComponent.getInitialProps) {
  //   Wrapper.getInitialProps = WrapperComponent.getInitialProps
  // }

  Wrapper.propTypes = {
    application: PropTypes.string,
    queryData: PropTypes.any,
    router: PropTypes.object,
  }

  return Wrapper
}

export default WithSignUp
